export default {"src":"/_next/static/media/IconLinkedIn.f67ec711.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};